export const ENDPOINTS = {
  ME: '/me.php',
  LOGIN: '/login.php',
};
